import { useCallback, useContext, useState } from 'react';
import { DeleteMomentContext, SetQuoteMomentIdContext, StarQuoteContext, TranscriptQuoteMomentIdContext, TranscriptToggleStarQuoteContext } from '@trinity/chat-components/containers/Transcript/context.js';
import type { StarQuoteOptions } from './context';

type Props = {
  children: React.ReactNode;
  initialQuoteMomentId?: number;
  range: {
    start: number;
    end: number;
  };
  transcriptId: number;
};

export const TranscriptGoodQuoteContainer = ({
  initialQuoteMomentId,
  range,
  transcriptId,
  ...props
}: Props) => {

  const [quoteMomentId, setQuoteMomentId] = useState<number>(initialQuoteMomentId);

  const starQuote = useContext(StarQuoteContext);
  const deleteMoment = useContext(DeleteMomentContext);

  const handleStarQuote = useCallback((options?: StarQuoteOptions) => {
    return starQuote({
      fromTs: range.start,
      toTs: range.end,
      transcriptId,
    }, {
      ...options,
      onSuccess: (res, variables, context) => {
        setQuoteMomentId(res.tag.id);
        options?.onSuccess?.(res, variables, context);
      },
    });
  }, [starQuote, range, transcriptId]);

  const handleToggleStarQuote = useCallback(() => {
    if (quoteMomentId) {
      return deleteMoment({
        momentId: quoteMomentId,
        transcriptId,
      });
    } else {
      return handleStarQuote();
    }
  }, [quoteMomentId, deleteMoment, handleStarQuote, transcriptId]);

  return (
    <SetQuoteMomentIdContext.Provider value={setQuoteMomentId}>
      <TranscriptQuoteMomentIdContext.Provider value={quoteMomentId}>
        <TranscriptToggleStarQuoteContext.Provider value={handleToggleStarQuote}>
          {props.children}
        </TranscriptToggleStarQuoteContext.Provider>
      </TranscriptQuoteMomentIdContext.Provider>
    </SetQuoteMomentIdContext.Provider>
  );
};